/* eslint-disable react/no-array-index-key */
import * as React from 'react';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState, useAppSelector } from 'app';
import farmer from 'assets/images/farmer.png';
import organization from 'assets/images/organization.png';
import shops from 'assets/images/shops.png';
import volunteer from 'assets/images/volunteer.png';
import { selectAppDevice } from 'slice';
import { COLLABORATOR_TEXT, DEVICES } from 'utils';

import ListAccountDesktop from './ListAccountDesktop';
import ListAccountMobile from './ListAccountMobile';

interface ListAccountProps {
  chooseAccountModal?: any;
  isAtModal?: boolean;
}

const DEFAULT_LIMIT = 100;

const ListAccount = ({
  chooseAccountModal,
  isAtModal,
}: ListAccountProps): JSX.Element => {
  const history = useHistory();
  const account = useSelector((state: RootState) => state.account.owner);
  const appDevice = useAppSelector(selectAppDevice);

  const handleClickEntity = (type: string) => {
    switch (type) {
      case 'farm':
        if (isAtModal) {
          chooseAccountModal(type);
        } else {
          history.push('/farm/create');
        }
        break;
      case 'store':
        if (isAtModal) {
          chooseAccountModal(type);
        } else {
          history.push('/store/create');
        }
        break;
      case 'collaborator':
        if (isAtModal) {
          chooseAccountModal(type);
        } else {
          history.push('/collaborator/create');
        }
        break;
      case 'warehouse':
        if (isAtModal) {
          chooseAccountModal(type);
        } else {
          history.push('/warehouse/create');
        }
        break;
      case 'transport':
        if (isAtModal) {
          chooseAccountModal(type);
        } else {
          history.push('/transport/create');
        }
        break;
      case 'volunteer':
        if (isAtModal) {
          chooseAccountModal(type);
        } else {
          history.push('/volunteer/create');
        }
        break;
      default:
    }
  };

  const entities = [
    {
      avatar: farmer,
      type: 'farm',
      disabled: false,
      name: `Nông trại (${
        account ? account.totalFarmAccount : 0
      }/${DEFAULT_LIMIT})`,
      description:
        'Tạo nông trại để khám phá các tính năng truy xuất, liên kết, mua bán, quản lý và nhiều hơn thế nữa.',
      background: 'rgba(57, 181, 74, 0.2)',
    },
    {
      avatar: shops,
      type: 'store',
      disabled: false,
      name: `Cửa hàng (${
        account ? account.totalStoreAccount : 0
      }/${DEFAULT_LIMIT})`,
      description:
        'Tạo cửa hàng để khám phá các tính năng truy xuất, liên kết, mua bán, quản lý và nhiều hơn thế nữa.',
      background: 'rgba(66, 118, 254, 0.2)',
    },
    {
      avatar: organization,
      type: 'collaborator',
      disabled: false,
      name: `${COLLABORATOR_TEXT.CAPITALIZE} (${
        account ? account.totalCollaboratorAccount : 0
      }/${DEFAULT_LIMIT})`,
      description: `Tạo ${COLLABORATOR_TEXT.LOWERCASE} để khám phá các tính năng truy xuất, liên kết, mua bán, quản lý và nhiều hơn thế nữa.`,
      background: 'rgba(66, 231, 254, 0.2)',
    },
    {
      avatar: volunteer,
      type: 'volunteer',
      disabled: true,
      name: `Thiện nguyện (${
        account ? account.totalVolunteerAccount : 0
      }/${DEFAULT_LIMIT})`,
      description:
        'Tạo thiện nguyện để khám phá các tính năng truy xuất, liên kết, mua bán, quản lý và nhiều hơn thế nữa.',
      background: 'rgba(98, 244, 54, 0.2)',
    },
  ];

  const renderElements = {
    [DEVICES.DESKTOP]: (
      <ListAccountDesktop
        entities={entities}
        handleClickEntity={handleClickEntity}
        isAtModal={isAtModal}
      />
    ),
    [DEVICES.MOBILE]: (
      <ListAccountMobile
        entities={entities}
        handleClickEntity={handleClickEntity}
      />
    ),
    [DEVICES.TABLET]: (
      <ListAccountMobile
        entities={entities}
        handleClickEntity={handleClickEntity}
      />
    ),
  };

  return <>{renderElements[appDevice.device]}</>;
};

export default ListAccount;
